"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationSelector = void 0;
var localization_selector_1 = require("./localization-selector");
Object.defineProperty(exports, "LocalizationSelector", { enumerable: true, get: function () { return localization_selector_1.LocalizationSelector; } });
